import { render, staticRenderFns } from "./FixItem.vue?vue&type=template&id=34841194&"
import script from "./FixItem.vue?vue&type=script&lang=ts&"
export * from "./FixItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports